import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldYear extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'year');
  }
}
